import { render, staticRenderFns } from "./DuplicateGroupCardItem.vue?vue&type=template&id=3dceba22&scoped=true&"
import script from "./DuplicateGroupCardItem.vue?vue&type=script&lang=js&"
export * from "./DuplicateGroupCardItem.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateGroupCardItem.vue?vue&type=style&index=0&id=3dceba22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dceba22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDivider,VIcon})
